import { FullStory, init as initFullStory } from "@fullstory/browser";

export const FULLSTORY_ORG_ID = "o-1M2PCX-na1";

/**
 * What the recorder has done in this page's life. It lives on `window.__attorneyHubBootstrap`
 * rather than in this module, because a hot reload re-runs this module and FullStory must not be
 * loaded twice, nor started twice.
 */
export type SessionRecorderState = {
  /** Set by `index.tsx` only where FullStory may run at all: never in local development or the functional tests. */
  fullStoryEnabled?: boolean;
  fullStoryInitialized: boolean;
  fullStoryCapturing?: boolean;
};

/**
 * Begins capture: for a signed-in visitor who has allowed it, and at no other time.
 *
 * FullStory is not loaded at bootstrap. The first start loads it, so before that moment the page
 * fetches nothing from FullStory and FullStory sets no cookies — the login page included. Capture
 * that was shut down resumes with `restart`.
 *
 * Does nothing where FullStory is not enabled, and nothing when capture is already running.
 */
export function startSessionRecording(
  state: SessionRecorderState | undefined = window.__attorneyHubBootstrap,
): void {
  if (!state?.fullStoryEnabled || state.fullStoryCapturing) return;

  if (state.fullStoryInitialized) {
    FullStory("restart");
  } else {
    initFullStory({ orgId: FULLSTORY_ORG_ID });
    state.fullStoryInitialized = true;
  }
  state.fullStoryCapturing = true;
}

/** Ends capture — on sign-out, or when a yes is withdrawn — without a reload. */
export function stopSessionRecording(
  state: SessionRecorderState | undefined = window.__attorneyHubBootstrap,
): void {
  if (!state?.fullStoryCapturing) return;

  FullStory("shutdown");
  state.fullStoryCapturing = false;
}
